import React, { Component } from "react"
import { connect, getIn } from "formik"
import _ from "lodash"
import path from "path"
import styles from "./styles.css"
import FileList from "./FileList"

class FormikFilePicker extends Component {
  props: {
    formik: any,
    name: string,

    label: string,
    disabled: boolean,
    multiple: boolean,
    canDeleteFiles: boolean,

    onFileClick: () => any,
  }

  onFileChange = ( name, formik ) => e => {
    const files = e.target.files
    this.formikChange( name, formik, files )
  }

  onFileDelete = ( name, formik, file ) => () => {
    const { multiple } = this.props
    if ( !multiple ) {
      this.formikChange( name, formik, undefined )
      return
    }

    const files = getIn( formik.values, name )
    const newFiles = files.filter( f => f.id !== file.id )
    this.formikChange( name, formik, newFiles )
  }

  formikChange = ( name, formik, files ) => {
    const { multiple } = this.props

    const fieldValue = multiple
      ? files
      : _.get( files, "[0]", null )

    formik.setFieldValue( name, fieldValue )
  }

  statusMessage = ( value, error, touched ) => {
    if ( touched && error ) {
      return error
    }

    return "Selecione um ficheiro"
  }

  renderUploadIsland = ( formik, value, name, statusMessage ) => {
    const labelName = "file-upload-" + name
    return (
      <div className={styles.uploadIsland}>
        <div className={styles.upload}>
          <label htmlFor={labelName}>
            <img
              className={styles.uploadIcon}
              src="/assets/img/upload_icon.svg"
              alt=""
              style={{
                cursor: this.props.disabled ? "not-allowed" : "pointer",
              }}
            />
          </label>
          <input
            type="file"
            id={labelName}
            onChange={this.onFileChange( name, formik )}
            onBlur={formik.handleBlur( name )}
            multiple={this.props.multiple}
            autoComplete="off"
          />
        </div>
        <div className={styles.info}>
          <div>{statusMessage}</div>
        </div>
      </div>
    )
  }

  fileList = value => {
    if ( !value ) {
      return []
    }

    if ( _.isArrayLike( value ) ) {
      return Array.from( value )
    }

    return [ value ]
  }

  renderFileList = ( formik, value, name ) => {
    const fileList = this.fileList( value )
      .map( file => ( {
        ...file,
        name: path.basename( file.name ),
        ext: path.extname( file.name ),
      } ) )

    return (
      <FileList
        files={fileList}
        onFileDelete={( file ) => this.onFileDelete( name, formik, file )}
        onFileClick={this.props.onFileClick}
      />
    )
  }

  render () {
    // TODO: handle disabled and multiple
    const { name, formik, label } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    const statusMessage = this.statusMessage( value, error, touched )

    return (
      <div className={styles.root}>
        <span className={styles.header}>{label}</span>
        <div className={styles.main}>
          {this.renderFileList( formik, value, name )}
          {this.renderUploadIsland( formik, value, name, statusMessage )}
        </div>
      </div>
    )
  }
}

export default connect( FormikFilePicker )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/FilePicker/index.jsx